export default [
  {
    label: 'Alert ID',
    name: 'Alert ID',
    key: 'alertId'
  },
  {
    label: 'Alert Date',
    name: 'Alert Date',
    key: 'alertDate'
  },
  {
    label: 'Alert Source',
    name: 'Alert Source',
    key: 'alertSourceId'
  },
  {
    label: 'Alert Level',
    name: 'Alert Level',
    key: 'alertLevel'
  },
  {
    label: 'Alert Score',
    name: 'Alert Score',
    key: 'alertScore'
  },
  {
    label: 'Account Number',
    name: 'Account Number',
    key: 'accountId'
  },
  {
    label: 'Account Currency',
    name: 'Account Currency',
    key: 'accountCurrency'
  },
  {
    label: 'Business Segment',
    name: 'Business Segment',
    key: 'segmentName'
  },
  {
    label: 'Typologies triggered',
    name: 'Typologies triggered',
    key: 'triggeredTypologies'
  },
  {
    label: 'Alert Status',
    name: 'Alert Status',
    key: 'alertStatus'
  },
  {
    label: 'Alert Close Date',
    name: 'Alert Close Date',
    key: 'closureDate'
  }
];
